import { Readable, Writable, derived, get, writable } from 'svelte/store';
import { getBetPerColor } from '../betting/betting';
import { getNormalizeNumberWithDecimals } from '../utils/global';
import { currencyDecimal, gameInitParams } from './misc';

export const showBetSizeChips = writable(false);

export const availableChips = writable([]);
export const selectedChipIndex = writable(null);
export const totalChipsBets = writable(null);
export const chipPrice: Writable<string> = writable(null);

export const chipBetPerColor: Writable<number[]> = writable(Array.from({ length: 8 }, () => 0));

export const betPerColor: Readable<number[]> = derived(
    [chipBetPerColor, chipPrice, currencyDecimal],
    ([$chipBetPerColor, $chipPrice, $currencyDecimal]) => {
        return $chipBetPerColor.map(bet => Number((bet * Number($chipPrice)).toFixed($currencyDecimal)));
    }
);

export const chipTotalBet = derived(chipBetPerColor, $chipBetPerColor =>
    $chipBetPerColor.reduce((sum, bet) => sum + bet, 0)
);

export const totalBet: Readable<string> = derived(
    [chipTotalBet, chipPrice, currencyDecimal],
    ([$chipTotalBet, $chipPrice, $currencyDecimal]) =>
        Number(Number($chipTotalBet) * Number($chipPrice)).toFixed($currencyDecimal)
);

export const betColorLimits: Writable<number[]> = writable([]);

export const isMaxedOut = derived([chipBetPerColor, betColorLimits], ([$chipBetPerColor, $betColorLimits]) => {
    if (!$chipBetPerColor || !$betColorLimits) return Array.from({ length: 8 }, () => false);
    return $chipBetPerColor.map((bet, index) => bet >= $betColorLimits[index]);
});

export const isAllMaxedOut = derived(isMaxedOut, $isMaxedOut => {
    if (!$isMaxedOut) return false;
    return $isMaxedOut.every(value => value);
});

export const initChipValues = betConfigs => {
    const $gameInitParams = get(gameInitParams).currency_attributes;
    const chipLimits: string[] = betConfigs?.chip_limits;
    const defaultChip: string = betConfigs?.chip_default || chipLimits[0];
    const defaultChipIndex: number = chipLimits.findIndex((chipValue: string) => chipValue === defaultChip);

    const normalizedChipPrice = getNormalizeNumberWithDecimals(
        betConfigs?.chip_price,
        $gameInitParams?.exponent,
        $gameInitParams?.subunits
    );
    chipPrice.set(normalizedChipPrice);

    currencyDecimal.set($gameInitParams?.subunits);

    availableChips.set(betConfigs?.chip_limits);
    selectedChipIndex.set(defaultChipIndex);
    chipBetPerColor.set(getBetPerColor());
};
